import React from "react"
import { Link } from "react-router-dom"
import { Button, Card, CardImg, CardTitle } from "reactstrap"

const EventsCard = ({
  to,
  url,
  mainTitle,
  subTitle,
  dateTime,
  cardClassName,
  isUpcoming,
  isSoldOut = false,
}) => {
  return (
    <>
      <section className="wrapper-eventcard">
        <Link to={to} className="text-decoration-none">
          <Card className={`wg-box mb-0 ${cardClassName}`}>
            <div className="wg-box-content-overlay"></div>
            <CardImg
              bottom
              className="img-fluid wg-box-img"
              src={url}
              alt="EventImage"
            />
          </Card>
        </Link>
        <Link to={to} className="text-decoration-none">
          <div className="card-content p-4">
            <p className="card-text card-content-title mb-2">
              <small className="text-primary font-weight-extrabold font-size-14">
                {dateTime}
              </small>
            </p>
            <div className="cards-inner">
              <CardTitle className="text-primary font-weight-bold mt-0 mb-0 wg-card-title">
                {mainTitle}
              </CardTitle>
              <p className="card-text text-primary font-weight-bold mt-1 font-size-18">
                {subTitle}
              </p>
            </div>
            {isUpcoming && (
              <>
                <div className="text-center mt-3">
                  <Link to={to}>
                    <Button className="btnbook-now btn btn-primary px-5 py-2 font-size-16 bg-primary text-white btn-md">
                      {isSoldOut ? "Sold Out" : "Book Now"}
                    </Button>
                  </Link>
                </div>
              </>
            )}
          </div>
        </Link>
      </section>
    </>
  )
}

export default EventsCard
